import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { TimeRange } from '@mi-front/core';

import { MIN_STREAM_FROM_LOOKBACK_MS } from '../../consts';
import { getStationStreamRetentionDays } from '../../helpers/get-station-stream-retention-days';
import { calculateAllowedRange } from '../range/calculate-allowed-range';

/**
 * Returns the allowed [from, to] range for the current station's stream time navigation.
 * - from: earliest allowed start of a stream range (start of day at now - retentionDays).
 * - to: upper bound — latest time that can be used as the start (from) of a stream range (now - 20 min).
 * Uses station retention via {@link getStationStreamRetentionDays}.
 * Use in time-move controls to validate that:
 * - Move backwards does not navigate before range.from.
 * - Move forwards does not navigate past range.to.
 */
export function useStationTimeMoveRange(): TimeRange<number> {
  const station = useActiveStation();
  const now = Date.now();
  const retentionDays = getStationStreamRetentionDays(station);

  return calculateAllowedRange(now, {
    retentionDays,
    lookbackMs: MIN_STREAM_FROM_LOOKBACK_MS,
  });
}
